import { Card } from "../../../components/ui/card";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import { 
  FileEdit, 
  Calculator, 
  Lightbulb, 
  ChevronDown,
  Heart, 
  Send 
} from "lucide-react";
import { useEffect, useState } from "react";

export const ProcessSection = () => {

  const [showMore, setShowMore] = useState(false);
  const getIsMobile = () =>
  typeof window !== "undefined" && window.matchMedia("(max-width: 639px)").matches;
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)"); // < sm
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  const processSteps = [
    {
      icon: FileEdit,
      title: "Enter your birth date and full name",
      description: "जन्म तिथि और पूरा नाम।"
    },
    {
      icon: Calculator,
      title: "Calculate core numerology numbers",
      description: "स्वचालित रूप से आपके मूलांक, भाग्यांक इत्यादि निकाले जाते हैं।"
    },
    {
      icon: Lightbulb,
      title: "Interpretation of numbers",
      description: "प्रत्येक अंक का अर्थ, प्रभाव और आपकी जीवन‑यात्रा पर प्रभाव।"
    },
    {
      icon: Heart,
      title: "Guidance & remedies",
      description: "करियर, रिश्तों, व्यक्तिगत विकास और remedies"
    },
    {
      icon: Send,
      title: "Receive your personalised report",
      description: "व्यक्तिगत रिपोर्ट ई‑मेल पर प्राप्त करें।"
    }
  ];

  const limit = isMobile ? 3 : 6;
  const visibleProcessSteps = showMore ? processSteps : processSteps.slice(0, limit);

  return (
    <section className="bg-gradient-to-b from-background-red to-cosmic-red/10">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Here Is Exactly How It Works
          </h2>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {visibleProcessSteps.map((step, index) => (
            <div key={index} className="relative">
              <Card className="p-6 h-full border-cosmic-gold/20 bg-card-red/50 backdrop-blur-sm hover:shadow-[0_0_20px_hsl(var(--mystic-gold)/0.2)] transition-all duration-300 relative">
                {/* Step Number */}
                <Badge className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-gradient-to-b from-cosmic-gold to-cosmic-gold-dark text-primary-foreground font-bold flex items-center justify-center">
                  {index + 1}
                </Badge>
                
                {/* Icon */}
                <step.icon className="w-12 h-12 text-cosmic-gold mb-4 mx-auto" />
                
                {/* Content */}
                <h3 className="text-xl font-semibold text-foreground mb-3 text-center">
                  {step.title}
                </h3>
                <p className="text-muted-foreground text-center text-sm">
                  {step.description}
                </p>
              </Card>

              {/* Connecting Arrow */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-b from-cosmic-gold to-cosmic-glow transform -translate-y-1/2 z-10">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-cosmic-gold border-t-2 border-b-2 border-t-transparent border-b-transparent"></div>
                </div>
              )}
            </div>
          ))}
        </div>
        {/* Show More Button */}
        {!showMore && (
          <div className="text-center pt-10 md:hidden">
            <Button 
              variant="cosmic-outline" 
              onClick={() => setShowMore(true)}
              className="group"
            >
              Show More
              <ChevronDown className="w-4 h-4 ml-2 group-hover:translate-y-1 transition-transform" />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};